import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  useOutsideClick,
} from '@chakra-ui/react';
import {colors, useCustomerContext} from 'components/providers';
import {CheckboxLanguage} from 'components/shared';
import useSafeReplaceLanguage from 'hooks/useSafeReplaceLanguage';
import {useRouter} from 'next/router';
import {FC, useRef, useState} from 'react';
import {setCookie} from 'react-use-cookie';
import {isObjEmpty} from 'utils/helpers';

import {MobileAccordionButton} from './components';

interface IProps {
  isDesktop: boolean;
  onChangeLanguage?: () => void;
  accordionMobileSize?: string;
}

export const LanguageSelector: FC<IProps> = ({isDesktop, onChangeLanguage, accordionMobileSize = 'auto'}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {locales, locale} = useRouter();
  const ref = useRef<any>();
  const acordeonBtnRef = useRef<any>();
  const {customer, updateCustomerData} = useCustomerContext();
  const {safeReplace} = useSafeReplaceLanguage();

  useOutsideClick({
    ref: ref,
    handler: () => {
      if (isMenuOpen) acordeonBtnRef?.current?.click();
    },
  });

  const onToggle = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const onChange = (lang: string) => {
    if (isDesktop) acordeonBtnRef?.current?.click();
    if (onChangeLanguage) onChangeLanguage();
    setIsMenuOpen(false);
    setCookie('NEXT_LOCALE', lang, {days: 365});
    safeReplace(lang);
    if (!isObjEmpty(customer)) updateCustomerWithNewLang(lang);
  };

  const updateCustomerWithNewLang = (lang: string) => {
    if (lang) {
      const tempCustomerData = {...customer, lang_code: lang};
      updateCustomerData(tempCustomerData, false);
    }
  };

  return (
    <Flex
      justifyContent={['space-between', 'center']}
      alignItems="center"
      px={['0px', '20px']}
      ref={ref}
      zIndex={99999}
      mr={['50px', '0px']}
      w="full"
    >
      <Accordion w={[accordionMobileSize, 'auto']} allowMultiple position={isDesktop ? 'absolute' : 'static'}>
        <AccordionItem zIndex={99999} border="none" borderRadius="16px">
          <h2>
            {isDesktop ? (
              <AccordionButton
                ref={acordeonBtnRef}
                _focus={{border: 'none'}}
                borderRadius="16px"
                bg={colors.lightGray}
                onClick={() => onToggle()}
              >
                <Box flex="1" textAlign="left">
                  {locale}
                </Box>
                <AccordionIcon />
              </AccordionButton>
            ) : (
              <MobileAccordionButton onToggle={onToggle} isMenuOpen={isMenuOpen} locale={locale} />
            )}
          </h2>
          {isDesktop ? (
            <AccordionPanel
              position="absolute"
              pb={4}
              bg={colors.white}
              border="1px solid"
              borderColor={colors.lightGray}
              borderRadius="16px"
              mt="10px"
              zIndex={99999}
            >
              <CheckboxLanguage language={locale} locales={locales} onChange={onChange} />
            </AccordionPanel>
          ) : (
            <AccordionPanel p="10px 45px">
              <CheckboxLanguage language={locale} locales={locales} onChange={onChange} />
            </AccordionPanel>
          )}
        </AccordionItem>
      </Accordion>
    </Flex>
  );
};
